import { Trans } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import { CountBadge } from '@/design_system/CountBadge';
import IconFilters from '@/icons/Filters.svg';
import { createBEMClasses } from '@/utils/classname';
import useViewPort from '@/utils/useViewport';

import './FiltersButton.css';

const { block } = createBEMClasses('filters-button');

export const FiltersButton = ({
  ref,
  onClick,
  onMouseDown,
  onKeyDown,
  count,
}: {
  ref?: React.Ref<HTMLButtonElement>;
  onClick?: () => void;
  onMouseDown?: () => void;
  onKeyDown?: () => void;
  count?: number;
}) => {
  const { isMobile, isTablet } = useViewPort();

  const isMobileOrTablet = isMobile || isTablet;

  return (
    <div className={block()}>
      <Button
        ref={ref}
        onClick={onClick}
        onMouseDown={onMouseDown}
        onKeyDown={onKeyDown}
        size={isMobileOrTablet ? 'large' : 'medium'}
        variant="secondary"
        iconOnly={isMobileOrTablet}
      >
        <IconFilters />
        {!isMobileOrTablet && <Trans id="filters.filters-button.label">Filters</Trans>}
      </Button>
      {isMobileOrTablet && !!count && <CountBadge count={count} variant="neutral" size="small" />}
    </div>
  );
};
